// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ht-z","tooltipWrapper":"it-z","icon":"jt-z","tooltip":"kt-z","content":"lt-z"};